import { render } from "./PostBake.vue?vue&type=template&id=65a227d8"
import script from "./PostBake.vue?vue&type=script&lang=ts"
export * from "./PostBake.vue?vue&type=script&lang=ts"
script.render = render

export default script